import { atom } from 'recoil'

type Props = {
  firstLoading: boolean
}

const viewerLoadingState = atom<Props>({
  key: 'viewerLoadingState',
  default: {
    firstLoading: true
  }
})

export default viewerLoadingState
